(function () {
	const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
	});

	initProductAccordion();
})();


document.addEventListener("variant:change", function (event) {
    if (!event.detail || !event.detail.variant) return;

    const variant = event.detail.variant;
    const skuElement = document.querySelector('.product__sku');

    if (skuElement) {
        skuElement.innerHTML = `<span class="product__sku-title">SKU: </span>${variant.sku || "N/A"}`;
        skuElement.classList.toggle('visibility-hidden', !variant.sku);
    }
});
